export default function WhatIsSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-label font-semibold text-primary-700 bg-primary-100/80 rounded-full mb-3">
            About
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            What Is VigorBuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            VigorBuy Spreadsheet is a structured product discovery resource designed to help shoppers organize, compare, and explore products efficiently. Instead of spending hours searching through scattered information, users can use a spreadsheet-based system to discover categories, compare options, review product details, and make smarter purchasing decisions.
          </p>
        </div>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-left text-sm">
            <thead>
              <tr className="bg-background-200/50">
                <th className="px-5 py-4 font-label font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                <th className="px-5 py-4 font-label font-semibold text-foreground-500 whitespace-nowrap">Without Spreadsheet</th>
                <th className="px-5 py-4 font-label font-semibold text-primary-600 whitespace-nowrap">
                  <div className="w-4 h-4 inline-flex items-center justify-center mr-1">
                    <i className="ri-star-fill text-accent-400"></i>
                  </div>
                  VigorBuy Spreadsheet
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-background-200/50">
              {[
                { feature: 'Product Discovery', without: 'Slow Searching', with: 'Organized Database' },
                { feature: 'Category Browsing', without: 'Random', with: 'Structured' },
                { feature: 'Comparison', without: 'Difficult', with: 'Simple' },
                { feature: 'Beginner Experience', without: 'Confusing', with: 'Easy' },
                { feature: 'Time Saving', without: 'Low', with: 'High' },
                { feature: 'Updates', without: 'Irregular', with: 'Regularly Refreshed' },
              ].map((row) => (
                <tr key={row.feature} className="hover:bg-background-50/50 transition-colors">
                  <td className="px-5 py-3.5 font-label font-medium text-foreground-800">{row.feature}</td>
                  <td className="px-5 py-3.5 text-foreground-500">{row.without}</td>
                  <td className="px-5 py-3.5 text-primary-600 font-medium">{row.with}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}